import script from "./AppointInfoPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointInfoPopup.vue?vue&type=script&setup=true&lang=ts"

import "./AppointInfoPopup.vue?vue&type=style&index=0&id=2f9c0c64&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f9c0c64"]])

export default __exports__